import { ReactNode } from 'react';

import { Container } from './styles';

export function NoDataTable({
  icon,
  description,
}: {
  icon: ReactNode;
  description: string;
}): JSX.Element {
  return (
    <Container>
      {icon}
      <p>{description}</p>
    </Container>
  );
}
